import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Avatar,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import FoundationIcon from '@mui/icons-material/Foundation';
import VisibilityIcon from '@mui/icons-material/Visibility';

// Images
import Infra from './Images/Infra.jpg';
import I1 from './Images/I1.jpeg'; import I2 from './Images/I2.jpeg'; import I3 from './Images/I3.jpeg';
import I4 from './Images/I4.jpeg'; import I5 from './Images/I5.jpeg'; import I6 from './Images/I6.jpeg';
import I7 from './Images/I7.jpeg'; import I8 from './Images/I8.jpeg'; import I9 from './Images/I9.jpg';
import I10 from './Images/I10.JPG';
import C1 from './Images/C1.jpeg'; import C2 from './Images/C2.jpeg'; import C3 from './Images/C3.jpeg';
import C4 from './Images/C4.jpeg'; import C5 from './Images/C5.jpeg'; import C6 from './Images/C6.jpeg';
import C7 from './Images/C7.jpeg'; import C8 from './Images/C8.jpeg'; import C9 from './Images/C9.jpeg';
import C10 from './Images/C10.jpeg'; import C11 from './Images/C11.jpeg'; import C12 from './Images/C12.jpeg';
import C13 from './Images/C13.jpeg'; import C14 from './Images/C14.jpeg'; import C15 from './Images/C15.jpeg';
import C16 from './Images/C16.jpeg'; import C17 from './Images/C17.jpeg'; import C18 from './Images/C18.jpeg';
import C19 from './Images/C19.jpeg'; import C20 from './Images/C20.jpeg'; import C21 from './Images/C21.jpeg';
import C22 from './Images/C22.jpeg'; import C23 from './Images/C23.jpeg'; import C24 from './Images/C24.jpeg';
import C25 from './Images/C25.jpeg'; import C26 from './Images/C26.jpeg'; import C27 from './Images/C27.JPG';
import C28 from './Images/C28.JPG'; import C29 from './Images/C29.JPG'; import C30 from './Images/C30.JPG';
import C31 from './Images/C31.JPG'; import C32 from './Images/C32.JPG';
import M1 from './Images/M1.JPG'; import M2 from './Images/M2.JPG'; import M3 from './Images/M3.JPG';
import M4 from './Images/M4.JPG'; import M5 from './Images/M5.JPG'; import M6 from './Images/M6.jpg';
import M7 from './Images/M7.JPG'; import M8 from './Images/M8.JPG'; import M9 from './Images/M9.jpg';
import M10 from './Images/M10.JPG'; import M11 from './Images/M11.JPG'; import M12 from './Images/M12.JPG';
import M13 from './Images/M13.JPG'; import M14 from './Images/M14.JPG'; import M15 from './Images/M15.jpg';
import M16 from './Images/M16.jpg'; import M17 from './Images/M17.jpg'; import M18 from './Images/M18.jpg';
import M19 from './Images/M19.jpg'; import M20 from './Images/M20.jpg';
import Renovation from './Images/Renovation.jpg';
import Building from './Images/Building.jpg';

const BusinessCards = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const { t, i18n } = useTranslation();
  const direction = i18n.dir();
  const isRTL = direction === 'rtl';
  const fontFamily = isRTL ? "'Tajawal', Arial, sans-serif" : "Arial, Helvetica, sans-serif";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (selectedCard?.images?.length) {
      selectedCard.images.forEach((imgSrc) => {
        const img = new Image();
        img.src = imgSrc;
      });
    }
  }, [selectedCard]);

  const cardsData = [
    {
      id: 1,
      images: [Building, C1, C2, C20, C21, C22, C23, C24, C25, C26, C3, C4, C5, C6, C7, C8, C9, C10, C11, C12, C13, C14, C15, C16, C17, C18, C19, C27, C28, C29, C30, C31, C32],
      title: t("constructions"),
      icon: LocationCityIcon
    },
    {
      id: 2,
      images: [Infra, I1, I2, I3, I4, I5, I6, I7, I8, I9, I10],
      title: t("infrastructure"),
      icon: ApartmentOutlinedIcon
    },
    {
      id: 3,
      images: [Renovation, M1, M2, M3, M4, M5, M6, M7, M8, M9, M10, M11, M12, M13, M14, M15, M16, M17, M18, M19, M20],
      title: t("renovationMaintenance"),
      icon: FoundationIcon
    }
  ];

  const handleOpen = (card) => {
    setSelectedCard(card);
  };

  const handleClose = () => {
    setSelectedCard(null);
  };

  return (
    <div>
      {/* Styles */}
      <style>{`
        .card-3d {
          perspective: 1200px;
          display: inline-block;
        }

        .card-3d .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          transform-style: preserve-3d;
          box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.49);
          border-radius: 10px;
          position: relative;
          z-index: 1;
        }

        .card-3d .card:hover {
          transform: rotateY(10deg) rotateX(5deg);
          box-shadow: 0px 25px 50px rgba(0, 0, 0, 0.25);
          z-index: 2;
        }

        .card-3d .overlay {
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 3;
        }

        .card-3d .card:hover .overlay {
          opacity: 1;
        }

        .card-3d .overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }
      `}</style>

      {/* Header */}
      <Box
        sx={{
          backgroundColor: 'white',
          px: 2,
          py: 5,
          textAlign: 'center'
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontFamily,
            fontSize: { xs: '2rem', md: '3rem' },
            color: '#333'
          }}
        >
          {t("ourBusinessTitle") || "Our Business"}
        </Typography>
       <Typography
  variant="body1"
  sx={{
    mt: 2,
    maxWidth: "800px",
    mx: "auto", // Centers the text horizontally
    color: '#4a4a4a',
    lineHeight: 1.6,
    fontFamily,
    textAlign: 'center' // Centers the text inside the container
  }}
>
  {t("businessIntroduction") || "We provide a wide range of services including construction, infrastructure development, and property renovation. Our expertise ensures the highest quality and value for your property."}
</Typography>

      </Box>

      {/* 3D Cards */}
      <Grid container spacing={3} sx={{ pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, mb:7, backgroundColor: 'white' }}>
        {cardsData.map((card) => (
          <Grid item xs={12} sm={6} md={4} key={card.id} sx={{ display: 'flex' }}>
            <Box className="card-3d" sx={{ width: '100%' }}>
           <Card
  onClick={() => handleOpen(card)}
  className="card"
  sx={{
    borderRadius: 4,
    height: '500px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${card.images[0]})`,
    color: '#fff', // Ensures text is light
  }}
>
  {/* Dark Overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.14)',
      zIndex: 1,
      borderRadius: 2
    }}
  />

  {/* Content on top of the image and overlay */}
  <Box
    sx={{
      position: 'relative',
      zIndex: 2,
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: 3
    }}
  >
    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.8)', mb: 2 }}>
      {React.createElement(card.icon, { sx: { color: '#333' } })}
    </Avatar>
    <Typography
      variant="h6"
      sx={{
        fontWeight: 600,
        fontFamily,
        color: '#fff', // Title text over dark overlay
        textShadow: '0 1px 3px rgba(0,0,0,0.6)' // Improves readability
      }}
    >
      {card.title}
    </Typography>
  </Box>
</Card>

            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Modal Dialog */}
      <Dialog
        open={Boolean(selectedCard)}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontFamily
          }}
        >
          {selectedCard?.title}
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {selectedCard?.images.map((img, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card sx={{ borderRadius: '15px', overflow: 'hidden' }}>
                  <Box
                    component="img"
                    src={img}
                    alt={`Preview ${index}`}
                    sx={{
                      width: "100%",
                      height: 200,
                      objectFit: "cover",
                      display: "block"
                    }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default BusinessCards;
